import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  getTerms() {
    return defaultClient.get('/contracts/terms/')
  },
  getTermsByCode(code, param) {

    return defaultClient.get(`/contracts/terms/${code}?${qs.stringify(param)}`)
  },

  getTermsContentByCode(code, param) {

    console.log('code=', code)
    console.log('param=', param)
    console.log(defaultClient.get(`/contracts/terms/code/?code=${code}`))

    return defaultClient.get(`/contracts/terms/code/?code=${code}`)
  },

  getTermsByParam(param) {
    return defaultClient.get(`/contracts/terms/?${qs.stringify(param)}`)
  },

  getKcsTerms() {
    
    const result = defaultClient.get('/contracts/terms/?serviceCode=credit_note')

    console.log('result : ', result)

    return result
  },

}
